import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { registerSW } from 'virtual:pwa-register';
import App from './App';
import './index.css';
import './i18n'; // initialize i18next before App mounts

// Register PWA service worker with auto-update
const updateSW = registerSW({
  // Check for SW updates every 60 seconds
  immediate: true,
  onNeedRefresh() {
    // Auto-update without prompting
    updateSW(true);
  },
  onOfflineReady() {
    console.log('Application prête pour utilisation hors ligne');
  },
  onRegistered(registration) {
    console.log('Service Worker enregistré:', registration);
  },
  onRegisterError(error) {
    console.error('Erreur enregistrement Service Worker:', error);
  }
});

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60, // 1 minute
      retry: 1,
      refetchOnWindowFocus: true,
      refetchOnMount: 'always',
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
